<app-loader [isLoading]="isLoading"></app-loader>

<div class="login">
  <img src="img/serveto-black.png" alt="serveto-logo" (click)="byPassOTP()"/>
  <small>
    @if (environment != ''){
    {{environment}} -} {{version}}</small>
  @if (!isSubmitted) {
  <!-- Login form -->
  <mat-form-field appearance="outline">
    <mat-label>Usuario</mat-label>
    <input matInput type="text" [(ngModel)]="username" name="username" (keyup.enter)="loginOtp()">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Contraseña</mat-label>
    <input matInput [type]="hide() ? 'password' : 'text'" [(ngModel)]="password" name="password"
      (keyup.enter)="loginOtp()" />
    <button mat-icon-button matSuffix (click)="clickEvent($event)" [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hide()">
      <mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
    </button>
  </mat-form-field>

  <button class="log" (click)="loginOtp()">Entrar</button>
  } @else {
  <!-- OTP verification form -->
  <mat-form-field appearance="outline">
    <mat-label>Código de verificación</mat-label>
    <input matInput [type]="hide() ? 'password' : 'text'" [(ngModel)]="code" name="code" (keyup.enter)="validateOtp()">
    <button mat-icon-button matSuffix (click)="clickEvent($event)" [attr.aria-label]="'Hide password'"
      [attr.aria-pressed]="hide()">
      <mat-icon>{{hide() ? 'visibility_off' : 'visibility'}}</mat-icon>
    </button>
  </mat-form-field>

  <div class="button-group">
    <button class="log" (click)="validateOtp()">Verificar</button>
    <button class="back-button" (click)="goBack()">Volver</button>
  </div>
  }

  @if (errorMessage) {
  <div class="error-message">
    {{ errorMessage }}
  </div>
  }
  @if(doTheMagic) {
      <p id="magic">no OTP</p>
  }

  <!-- Login con Azure AD -->
  <!-- @if(token()) {
  <button class="log" (click)="onLogin()">Entrar como {{ profile() }}</button>
  <button class="log" (click)="logoutAzure()">Salir</button>
  } @else {
  <button class="log" (click)="loginAzure()">Login con Azure</button>
  } -->
</div>